import { Modal, ModalProps } from "antd";
import styled from "styled-components";

import { device } from "@constants/styles";
import { colors } from "@constants/colors";
import { ButtonBlock } from "@components/Buttons";
import { useMyTranslation } from "@components/Lang";

type Props = {
  open: boolean;
  onOk: () => void;
  onClose: () => void;
};

const ModalLogout = ({
  open = false,
  onOk = () => {},
  onClose = () => {},
  ...props
}: Props & ModalProps) => {
  const { t } = useMyTranslation();
  return (
    <Content id="model-logout" className="modal">
      <Modal
        title=""
        open={open}
        closable={false}
        footer={null}
        centered={true}
        getContainer={() =>
          document.getElementById("model-logout") as HTMLElement
        }
        {...props}
      >
        <div className="modal__content">
          <div className="color-black font-sukhumvitSet-bold size-20">
            {t("signout.title")}
          </div>
          <div className="modal__btn">
            <ButtonBlock
              text={t("signout.cancel")}
              bgColor="#fff"
              className="modal__btn--cancel"
              onClick={onClose}
            />
            <ButtonBlock
              text={t("signout.confirm")}
              className="modal__btn--cf"
              onClick={onOk}
            />
          </div>
        </div>
      </Modal>
    </Content>
  );
};

export default ModalLogout;

const Content = styled.div`
  width: 100%;
  max-width: 90% !important;
  & .ant-modal-content {
    border-radius: 0.833vw;
    @media ${device.desktopL} {
      border-radius: 12px;
    }
  }
  & .ant-modal {
    width: 25vw !important;
    @media ${device.desktopL} {
      width: 360px !important;
    }
  }
  & .ant-modal-mask {
    background-color: rgba(0, 0, 0, 0.7) !important;
  }
  .modal {
    &__content {
      text-align: center;
    }
    &__btn {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      margin: 2.083vw 0 0;
      &--cancel {
        color: ${colors.ppDark};
        border: 0.139vw solid ${colors.ppDark};
        width: 48%;
      }
      &--cf {
        width: 48%;
      }
      @media ${device.desktopL} {
        margin: 30px 0 0;
        &--cancel {
          border: 2px solid ${colors.ppDark};
        }
      }
    }
  }
`;
